<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {}
}
</script>

<style>
/* 全局样式 */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  background: #fff;
  font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;
}

body {
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: #fff;
}

#app {
  width: 100%;
  max-width: 430px;
  margin: 0 auto;
}

/* 通用样式 */
.container {
  width: 100vw;
  max-width: 430px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
}

/* 响应式 */
@media (max-width: 430px) {
  .container { padding: 0 8px; }
}
</style>
